import { gql } from '@apollo/client';

/**
 * Mutual-fund KYC, as the admin console does it.
 *
 * Two steps, and they answer different questions. `mfCheckKyc` asks NSE what
 * it holds for a client — it resolves PAN, date of birth and name server-side
 * from the user id, so the only thing to send is that id. `mfKycFreshRegister`
 * starts NSE-hosted eKYC and emails the client a link; that link is what
 * actually completes the KYC, so nothing here "submits" it on their behalf.
 *
 * The verdict is `kycStatusRemark` ("KYC Validated", "KYC REGISTERED");
 * `kycStatus` is NSE's bare code and `kraName` the registry that holds the
 * record. The result carries no UCC and no "was NSE asked" flag.
 */
export const MF_CHECK_KYC = gql`
  mutation MfCheckKyc($userId: Int) {
    mfCheckKyc(userId: $userId) {
      success
      pan
      kycStatus
      kycStatusRemark
      kraName
      name
      message
    }
  }
`;

/**
 * The onboarding record itself — the distributor completing or correcting KYC
 * on a client's behalf, rather than only starting NSE's hosted flow.
 *
 * `submit: false` saves what has been filled so far; `submit: true` files it.
 * The input is flat, while the read groups the same fields under
 * personalDetails / bankDetails / declarations — so the screen flattens on the
 * way in and groups on the way out.
 *
 * The operation is named KycOnboardingUpdate rather than KycOnboarding: the
 * query in queries/clients.js already owns that operation name, and two
 * documents sharing one name is an Apollo warning and a debugging trap.
 */
export const KYC_ONBOARDING_UPDATE = gql`
  mutation KycOnboardingUpdate($data: KycOnboardingUpdateInput!, $userId: Int) {
    kycOnboarding(data: $data, userId: $userId) {
      success
      message
      accountId
      ekycEmailSent
    }
  }
`;

export const MF_KYC_FRESH_REGISTER = gql`
  mutation MfKycFreshRegister($email: String!, $userId: Int) {
    mfKycFreshRegister(email: $email, userId: $userId) {
      success
      message
      link
      emailSent
    }
  }
`;
